var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImgCell',{attrs:{"image":_vm.logo_url,"label":_vm.label,"variant":_vm.variant,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }